import {Component, Input, OnInit} from "@angular/core";
import {NgbModal, NgbModalOptions, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {ActivatedRoute, RouterModule} from "@angular/router";
import {RaygunService} from "../../../../shared/services/raygun.service";
import {StyleService} from "../../../../shared/components/style/style.service";
import {PrivacyPolicyComponent} from "../../../../shared/components/privacy-policy/privacy-policy.component";
import {TermsAndConditionsComponent} from "../../../../shared/components/terms-and-conditions/terms-and-conditions.component";
import {ZendeskHelpComponent} from "../../../../shared/components/zendesk-help/zendesk-help.component";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-login-footer',
    templateUrl: './login-footer.component.html',
    imports: [
        CommonModule,
        RouterModule,
        NgbModule
    ]
})
export class LoginFooterComponent implements OnInit {
  constructor(private _modalService: NgbModal, private raygunService: RaygunService, private _styleService: StyleService, private _route: ActivatedRoute) {
  }
  
  @Input() public showLinks: boolean = true;
  
  async ngOnInit() {
    this.killModals();
    if (this.showLinks) {
      var params = await firstValueFrom(this._route.queryParams);

      if (params["action"] == "openHelp") {
        this.openHelp();
      }
    }
  }

  public get versionDetail(): string {
    return this.raygunService.versionDetail;
  }

  openPrivacy() {
    let ngbModalOptions: NgbModalOptions = {
      windowClass: "modal-custom"
    };
    this._modalService.open(PrivacyPolicyComponent, ngbModalOptions);

  }

  openTermsAndConditions() {
    let ngbModalOptions: NgbModalOptions = {
      windowClass: "modal-custom"
    };
    this._modalService.open(TermsAndConditionsComponent, ngbModalOptions);
  }

  openHelp() {
    let ngbModalOptions: NgbModalOptions = {
      windowClass: "modal-custom"
    };
    this._modalService.open(ZendeskHelpComponent, ngbModalOptions);
  }

  public get isUsingCustomDesign() {
    return this._styleService.isCustom;
  }
  
  public async killModals() {
    if (this._modalService.hasOpenModals()) {
      this._modalService.dismissAll();
    }
  }

  public get getYear() {
    return (new Date()).getFullYear();
  }
}
